import MainFiltersBQ from "../../../../../Global/Models/Filters/MainFiltersBQ";

export default class PotmUserVotesFilters extends MainFiltersBQ {
  matchIds?: string[] = null;

  constructor(filters: any) {
    super(filters);
    this.matchIds = filters && filters.matchIds ? filters.matchIds : null;
  }

  constructFiltersUrl?(): string {
    let url = super.constructMainFiltersUrl();

    if (this.matchIds && this.matchIds.length > 0) {
      url += "&";
      url += `match_ids=${this.matchIds.join(",")}`;
    }

    return url;
  }
}
